import React from 'react';
import { Table, DateTimeUtils } from 'dyl-components';
import { Icon } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

const DirectCustomerRow = ({ data, search }) => {
    
    return (
        <Table.Row>
            <Table.Cell />
            {search === "" && <Table.Cell />}
            <Table.Cell>
                <Icon name='crown' className="GroupsPage__directCustomerRow" />
                <Link to="/group/direct_customer">Direct Customer</Link>
            </Table.Cell>
            <Table.Cell>
                {data?.contact_count || "0"}
            </Table.Cell>
            <Table.Cell>
                Personal
            </Table.Cell>
            <Table.Cell />
            <Table.Cell />
            <Table.Cell>
                {data?.last_modified && (
                    <>
                        <div><b>{DateTimeUtils.formatEpoch(data.last_modified, DateTimeUtils.WORD_DATE_FORMAT)}</b></div>
                        <div>{DateTimeUtils.formatEpoch(data.last_modified, DateTimeUtils.TIME_FORMAT)}</div>
                    </>
                )}
            </Table.Cell>
            <Table.Cell />
        </Table.Row>
    )
}

export default DirectCustomerRow;
